module.exports = __webpack_public_path__ + "img/bee-welcome-left.af467839.svg";